import Vue from "vue";
import { userBehaviorInsertRecordWebsite } from "../services/home";
import { isValEmpty, isSpider } from "../utils/common";
import { CookieKeys, Cookies } from "./cookieKey";
/**
 * 用户功能埋点（前置条件：已登录）
 * @param deed 用户行为 0访问 1复制 2点击 3曝光
 * @param oid 事件编号
 * @param extra 其他属性 https://wiki.intra.qianlima.com/pages/viewpage.action?pageId=9635786
 */
const tracker = (deed, oid, extra = {}) => {
  console.log(deed, oid, extra);
  // 模拟登录，不埋点
  if (Cookies.get(CookieKeys.rem_login)) return;
  // 爬虫访问，不埋点
  if (isSpider()) return;

  if (typeof deed !== "number" && !deed) return console.error("埋点缺少必要参数：[deed]");
  if (typeof oid !== "number" && !oid) return console.error("埋点缺少必要参数：[oid]");
  deed = parseInt(deed);
  oid = parseInt(oid);

  const data = {};
  const userInfo = Cookies.get(CookieKeys.userInfo) || {};
  if (typeof extra.ctx === "number" || extra.ctx) data.ctx = extra.ctx;
  if (typeof extra.cid === "number" || extra.cid) data.cid = extra.cid;
  if (typeof extra.suid === "number" || extra.suid) data.suid = extra.suid;
  data.deed = deed;

  data.extendinfo = !isValEmpty(extra.extendinfo) ? extra.extendinfo : navigator.userAgent;
  data.level = userInfo.memberLevel || 0;
  data.oid = oid;
  data.refer = document.referrer;
  data.source = extra.source ? extra.source : "gw";
  data.uid = extra.uid ? extra.uid : userInfo.userId || 0;
  data.url = window.location.href;
  data.username = extra.username ? extra.username : userInfo.username;
  userBehaviorInsertRecordWebsite({ ...data })
    .then((res) => res)
    .catch((e) => e);
};
Vue.prototype.$track = (deed, oid, extra = {}) => {
  tracker(deed, oid, extra);
};

// 全局埋点方法
const trackDirective = {};
trackDirective.install = (Vue) => {
  Vue.directive("track", {
    bind: (el) => {
      /** el可以获取当前dom节点，并且进行编译，也可以操作事件 **/
      /** binding指的是一个对象，一般不用 **/
      /** vnode 是 Vue 编译生成的虚拟节点 **/
      el.addEventListener("click", () => {
        if (el.dataset.oid) {
          // alert(JSON.stringify(el.dataset));
          tracker(2, el.dataset.oid, { ...el.dataset });
        }
      });
    },
  });
};
export default trackDirective;
